
import "./App.css";
import HomeLayout from "./components/HomeLayout";

function App() {
  return (
    <div className="App">
      <HomeLayout />
    </div>
  );
}

export default App;
